import React, { useCallback, useEffect, useMemo } from 'react';
import _ from 'lodash';
import { useFormContext } from 'react-hook-form';
import { INTERNAL_ID_FIELD } from '../../form/FormConstants';
import CredentialList from './CredentialList';

const EMPTY_CREDENTIALS = [];

function ensureInternalIds(list = []) {
    let changed = false;

    const normalized = list.map((cred) => {
        if (cred?.[INTERNAL_ID_FIELD]) {
            return cred;
        }

        changed = true;
        return { ...cred, [INTERNAL_ID_FIELD]: _.uniqueId('cred_') };
    });

    return changed ? normalized : list;
}

export default function CredentialFieldArray({ name = 'credentials', setSelectionIsDirty, hasWinrmCert = false }) {
    const { watch, setValue } = useFormContext();
    const rawCredentials = watch(name) ?? EMPTY_CREDENTIALS;
    const credentials = useMemo(() => ensureInternalIds(rawCredentials), [rawCredentials]);

    useEffect(() => {
        if (credentials !== rawCredentials) {
            setValue(name, credentials, { shouldDirty: false });
        }
    }, [credentials, rawCredentials, name, setValue]);

    const handleChange = useCallback(
        (newList) => {
            setValue(name, ensureInternalIds(newList));

            if (_.isFunction(setSelectionIsDirty)) {
                setSelectionIsDirty(true);
            }
        },
        [name, setValue, setSelectionIsDirty]
    );

    return <CredentialList credentials={credentials} onChange={handleChange} hasWinrmCert={hasWinrmCert} />;
}
